var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForgotPassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "650px",
    height: "575px",
    viewBox: "0 0 650 575",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Illustration") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-6.1%",
    y: "-6.1%",
    width: "112.1%",
    height: "112.2%",
    filterUnits: "objectBoundingBox",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-12.9%",
    y: "-13.0%",
    width: "125.9%",
    height: "126.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M18.522,0 L47.956852,0 C49.5797169,-4.62229605e-15 50.9083654,1.29053846 50.955582,2.91271629 L51.0441727,5.95634921 C51.140728,9.27361621 53.8577434,11.9126984 57.1764153,11.9126984 L146.306792,11.9126984 C149.625464,11.9126984 152.342479,9.27361621 152.439035,5.95634921 L152.527625,2.91271629 C152.574842,1.29053846 153.903491,7.42204646e-16 155.526355,0 L184.961207,0 C195.190626,-1.87911363e-15 203.483207,8.29258186 203.483207,18.522 L203.483207,413.966891 C203.483207,424.19631 195.190626,432.488891 184.961207,432.488891 L18.522,432.488891 C8.29258186,432.488891 -5.85268494e-15,424.19631 0,413.966891 L0,18.522 C2.29997126e-15,8.29258186 8.29258186,-1.67360005e-15 18.522,0 Z",
    id: "path-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "81.1767625%",
    x2: "50%",
    y2: "-34.5130789%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8C19",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC967",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "62.1100647%",
    y1: "31.3809088%",
    x2: "62.1100647%",
    y2: "-27.4779882%",
    id: "linearGradient-6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8FDFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAD4FF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M23.4435696,4.26168224 L23.4435696,21.3084112 C23.4435696,23.1196262 22.0582677,24.5046729 20.2467192,24.5046729 L14.9186352,24.5046729 C14.2792651,24.5046729 13.8530184,24.0785047 13.8530184,23.4392523 C13.8530184,22.8 14.2792651,22.3738318 14.9186352,22.3738318 L20.2467192,22.3738318 C20.8860892,22.3738318 21.312336,21.9476636 21.312336,21.3084112 L21.312336,4.26168224 C21.312336,3.62242991 20.8860892,3.19626168 20.2467192,3.19626168 L14.9186352,3.19626168 C14.2792651,3.19626168 13.8530184,2.77009346 13.8530184,2.13084112 C13.8530184,1.49158879 14.2792651,1.06542056 14.9186352,1.06542056 L20.2467192,1.06542056 C22.0582677,1.06542056 23.4435696,2.45046729 23.4435696,4.26168224 Z M16.9433071,13.211215 C17.0498688,12.9981308 17.0498688,12.6785047 16.9433071,12.3588785 C16.8367454,12.2523364 16.8367454,12.1457944 16.7301837,12.0392523 L12.4677165,7.77757009 C12.0414698,7.35140187 11.4020997,7.35140187 10.975853,7.77757009 C10.5496063,8.20373832 10.5496063,8.84299065 10.975853,9.26915888 L13.4267717,11.7196262 L3.19685039,11.7196262 C2.55748031,11.7196262 2.1312336,12.1457944 2.1312336,12.7850467 C2.1312336,13.4242991 2.55748031,13.8504673 3.19685039,13.8504673 L13.4267717,13.8504673 L10.975853,16.3009346 C10.5496063,16.7271028 10.5496063,17.3663551 10.975853,17.7925234 C11.1889764,18.0056075 11.5086614,18.1121495 11.7217848,18.1121495 C11.9349081,18.1121495 12.2545932,18.0056075 12.4677165,17.7925234 L16.7301837,13.5308411 C16.8367454,13.4242991 16.9433071,13.317757 16.9433071,13.211215 Z",
    id: "path-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6211724,12.4299065 L22.3779528,12.4299065 L22.3779528,8.70093458 C22.3779528,4.59906542 19.0212598,1.24299065 14.9186352,1.24299065 C10.8160105,1.24299065 7.45931759,4.59906542 7.45931759,8.70093458 L7.45931759,12.4299065 L6.21609799,12.4299065 C4.10262467,12.4299065 2.4864392,14.0457944 2.4864392,16.1588785 L2.4864392,24.8598131 C2.4864392,26.9728972 4.10262467,28.588785 6.21609799,28.588785 L23.6211724,28.588785 C25.7346457,28.588785 27.3508311,26.9728972 27.3508311,24.8598131 L27.3508311,16.1588785 C27.3508311,14.0457944 25.7346457,12.4299065 23.6211724,12.4299065 Z M9.94575678,8.70093458 C9.94575678,5.96635514 12.1835521,3.72897196 14.9186352,3.72897196 C17.6537183,3.72897196 19.8915136,5.96635514 19.8915136,8.70093458 L19.8915136,12.4299065 L9.94575678,12.4299065 L9.94575678,8.70093458 Z M24.864392,24.8598131 C24.864392,25.6056075 24.3671041,26.1028037 23.6211724,26.1028037 L6.21609799,26.1028037 C5.47016623,26.1028037 4.97287839,25.6056075 4.97287839,24.8598131 L4.97287839,16.1588785 C4.97287839,15.4130841 5.47016623,14.9158879 6.21609799,14.9158879 L23.6211724,14.9158879 C24.3671041,14.9158879 24.864392,15.4130841 24.864392,16.1588785 L24.864392,24.8598131 Z",
    id: "path-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,0 L68.1751666,0 C71.4888751,8.22077476e-15 74.1751666,2.6862915 74.1751666,6 L74.1751666,55.7294372 C74.1751666,59.0431457 71.4888751,61.7294372 68.1751666,61.7294372 L6,61.7294372 C2.6862915,61.7294372 4.82055882e-15,59.0431457 0,55.7294372 L0,6 C-4.05812251e-16,2.6862915 2.6862915,6.08718376e-16 6,0 Z",
    id: "path-11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0398384,1.23119728e-13 L120.282546,1.23119728e-13 C125.789873,1.22108049e-13 130.260571,4.45295749 130.282467,9.96024091 L130.857435,154.572074 C130.879394,160.094877 126.420077,164.589795 120.897274,164.611754 C120.884021,164.611806 120.870768,164.611833 120.857514,164.611833 L10.6148064,164.611833 C5.10747945,164.611833 0.636782073,160.158875 0.614885444,154.651592 L0.0399174794,10.0397591 C0.0179591429,4.51695524 4.47727551,0.0220373761 10.0000794,7.90395561e-05 C10.0133323,2.63465709e-05 10.0265854,1.21345806e-13 10.0398384,1.23119728e-13 Z",
    id: "path-13"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-29.4%",
    y: "-22.8%",
    width: "171.0%",
    height: "156.5%",
    filterUnits: "objectBoundingBox",
    id: "filter-14"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 8,
    dy: 9,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0755212756   0 0 0 0 0.582569014   0 0 0 0 0.878793025  0 0 0 0.229458042 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    in: "shadowOffsetOuter2",
    result: "shadowBlurOuter2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.50398247   0 0 0 0 0.700178215   0 0 0 0 1  0 0 0 0.233828671 0",
    type: "matrix",
    in: "shadowBlurOuter2",
    result: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter2"
  }))), /*#__PURE__*/React.createElement("ellipse", {
    id: "path-15",
    cx: 25.1704298,
    cy: 25.5448757,
    rx: 25.1704298,
    ry: 25.5448757
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-76.5%",
    y: "-73.4%",
    width: "284.7%",
    height: "282.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-16"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 8,
    dy: 9,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0755212756   0 0 0 0 0.582569014   0 0 0 0 0.878793025  0 0 0 0.229458042 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    in: "shadowOffsetOuter2",
    result: "shadowBlurOuter2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.50398247   0 0 0 0 0.700178215   0 0 0 0 1  0 0 0 0.233828671 0",
    type: "matrix",
    in: "shadowBlurOuter2",
    result: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter2"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "47.2537592%",
    y1: "-28.1859254%",
    x2: "50%",
    y2: "91.0504812%",
    id: "linearGradient-17"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC6C6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCCA1",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "45.7543032%",
    y1: "-28.1859254%",
    x2: "50%",
    y2: "91.0504812%",
    id: "linearGradient-18"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC6C6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB2B2",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "44.569858%",
    y1: "-28.1859254%",
    x2: "50%",
    y2: "91.0504812%",
    id: "linearGradient-19"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC6C6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB2B2",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "44.0890061%",
    y1: "-28.1859254%",
    x2: "50%",
    y2: "91.0504812%",
    id: "linearGradient-20"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC6C6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCCA1",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "47.8437966%",
    y1: "-28.1859254%",
    x2: "50%",
    y2: "91.0504812%",
    id: "linearGradient-21"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC6C6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCCA1",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDCDD-Pages-New",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Forgot-Password",
    transform: "translate(-150.000000, -252.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Illustration",
    transform: "translate(156.000000, 252.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M469.402027,0 C565.829825,0 644,77.8709307 644,173.929592 C644,269.988253 565.829825,347.859184 469.402027,347.859184 C372.974229,347.859184 294.804054,269.988253 294.804054,173.929592 C294.804054,77.8709307 372.974229,0 469.402027,0 Z M469.402027,65.0204082 C409.022004,65.0204082 360.074324,113.780711 360.074324,173.929592 C360.074324,234.078473 409.022004,282.838776 469.402027,282.838776 C529.78205,282.838776 578.72973,234.078473 578.72973,173.929592 C578.72973,113.780711 529.78205,65.0204082 469.402027,65.0204082 Z",
    id: "Oval",
    fill: "#7367F0",
    fillRule: "nonzero",
    opacity: 0.052827381
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4966216,226.487755 C76.8328509,226.487755 98.9932432,248.563315 98.9932432,275.794898 C98.9932432,303.026481 76.8328509,325.102041 49.4966216,325.102041 C22.1603923,325.102041 0,303.026481 0,275.794898 C0,248.563315 22.1603923,226.487755 49.4966216,226.487755 Z M49.4966216,258.997959 C40.1842798,258.997959 32.6351351,266.518205 32.6351351,275.794898 C32.6351351,285.071591 40.1842798,292.591837 49.4966216,292.591837 C58.8089635,292.591837 66.3581081,285.071591 66.3581081,275.794898 C66.3581081,266.518205 58.8089635,258.997959 49.4966216,258.997959 Z",
    id: "Oval",
    fill: "#8BF78F",
    fillRule: "nonzero",
    opacity: 0.141020275,
    filter: "url(#filter-1)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fillOpacity: 0.0612161276,
    fill: "#7367F0",
    cx: 202.337838,
    cy: 433.469388,
    rx: 97.9054054,
    ry: 97.5306122
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#CEF5FF",
    opacity: 0.141020275,
    cx: 169.702703,
    cy: 92.1122449,
    rx: 34.8108108,
    ry: 34.677551
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fillOpacity: 0.135926573,
    fill: "#7367F0",
    filter: "url(#filter-2)",
    cx: 579.817568,
    cy: 433.469388,
    rx: 34.8108108,
    ry: 34.677551
  })), /*#__PURE__*/React.createElement("g", {
    id: "File-Organizer",
    transform: "translate(136.000000, 119.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Phone3",
    transform: "translate(66.539488, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.137,0 L194.942356,0 C208.825137,-2.55022564e-15 220.079356,11.2542182 220.079356,25.137 L220.079356,428.335568 C220.079356,442.21835 208.825137,453.472568 194.942356,453.472568 L25.137,453.472568 C11.2542182,453.472568 -4.35134254e-14,442.21835 -3.10027211e-14,428.335568 L-3.10027211e-14,25.137 C-3.62555852e-14,11.2542182 11.2542182,2.55022564e-15 25.137,0 Z",
    id: "Rectangle",
    fill: "#C4E3E7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-48",
    transform: "translate(7.937288, 9.138123)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Rectangle",
    fill: "#FFFFFF",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#7367F0",
    opacity: 0.0987723214,
    mask: "url(#mask-4)",
    cx: 77.1459911,
    cy: 263.229482,
    rx: 17.4529804,
    ry: 17.3275613
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.591171,245.901921 C228.129539,245.901921 265.856342,283.357614 265.856342,329.561553 C265.856342,375.765492 228.129539,413.221185 181.591171,413.221185 C135.052802,413.221185 97.3259997,375.765492 97.3259997,329.561553 C97.3259997,283.357614 135.052802,245.901921 181.591171,245.901921 Z M181.591171,282.452245 C155.385099,282.452245 134.14088,303.543801 134.14088,329.561553 C134.14088,355.579305 155.385099,376.67086 181.591171,376.67086 C207.797242,376.67086 229.041461,355.579305 229.041461,329.561553 C229.041461,303.543801 207.797242,282.452245 181.591171,282.452245 Z",
    id: "Oval",
    fill: "#C8F5D0",
    opacity: 0.141020275,
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.472656,74.2507662 L174.54205,74.2507662 C177.682124,74.2507662 180.227657,76.7962988 180.227657,79.9363723 C180.227657,83.0764458 177.682124,85.6219784 174.54205,85.6219784 L30.472656,85.6219784 C27.3325825,85.6219784 24.78705,83.0764458 24.78705,79.9363723 C24.78705,76.7962988 27.3325825,74.2507662 30.472656,74.2507662 Z",
    id: "Rectangle",
    fillOpacity: 0.642072771,
    fill: "#68DE9E",
    mask: "url(#mask-4)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M121.968816,7.93887177 C123.851436,7.93887177 125.377601,9.39346179 125.377601,11.1877895 C125.377601,12.9422433 123.918512,14.3718911 122.093783,14.4345646 L121.968816,14.4367073 L83.4238072,14.4367073 C81.5411871,14.4367073 80.015022,12.9821172 80.015022,11.1877895 C80.015022,9.43333574 81.4741112,8.00368799 83.2988401,7.94101448 L83.4238072,7.93887177 L121.968816,7.93887177 Z",
    id: "Path",
    fill: "#56CDD9",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.782748,7.39738548 C137.665368,7.39738548 139.191534,8.91258342 139.191534,10.7816748 C139.191534,12.6092308 137.732444,14.0984472 135.907715,14.1637321 L135.782748,14.1659641 L135.603957,14.1659641 C133.721337,14.1659641 132.195171,12.6507662 132.195171,10.7816748 C132.195171,8.95411878 133.654261,7.46490237 135.47899,7.39961747 L135.603957,7.39738548 L135.782748,7.39738548 Z",
    id: "Path",
    fill: "#56CDD9",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-37",
    transform: "translate(80.720034, 152.699134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4,0.764145455 L11.5936784,0.764145455 C13.8028174,0.764145455 15.5936784,2.55500646 15.5936784,4.76414545 L15.5936784,8.26640541 C15.5936784,8.93979339 16.1395672,9.48568221 16.8129552,9.48568221 L66.8225468,9.48568221 C69.0316858,9.48568221 70.8225468,11.2765432 70.8225468,13.4856822 L70.8225468,56.184096 C70.8225468,58.393235 69.0316858,60.184096 66.8225468,60.184096 L4,60.184096 C1.790861,60.184096 2.705415e-16,58.393235 0,56.184096 L0,4.76414545 C-2.705415e-16,2.55500646 1.790861,0.764145455 4,0.764145455 Z",
    id: "Rectangle",
    fill: "url(#linearGradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0193776,4.89053091 L72.3413,4.89053091 C73.014688,4.89053091 73.5605768,5.43641973 73.5605768,6.10980771 C73.5605768,6.1745848 73.5554147,6.23925889 73.5451394,6.30321583 L65.3849556,57.0950346 C65.289982,57.6861831 64.7798453,58.1209033 64.1811162,58.1209033 L9.85919378,58.1209033 C9.1858058,58.1209033 8.63991698,57.5750145 8.63991698,56.9016265 C8.63991698,56.8368494 8.64507913,56.7721753 8.65535442,56.7082183 L16.8155382,5.91639958 C16.9105118,5.32525107 17.4206485,4.89053091 18.0193776,4.89053091 Z",
    id: "Rectangle",
    fill: "url(#linearGradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.2919567,23.1775393 L73.1789658,54.3919343 C72.4437513,58.1461153 69.1535962,60.85443 65.3281008,60.85443 L4.85933937,60.85443 C2.65020037,60.85443 0.85933937,59.063569 0.85933937,56.85443 C0.85933937,56.5963739 0.884311594,56.3389234 0.933906892,56.0856779 L7.04689783,24.8712829 C7.78211228,21.1171019 11.0722674,18.4087872 14.8977628,18.4087872 L75.3665242,18.4087872 C77.5756632,18.4087872 79.3665242,20.1996482 79.3665242,22.4087872 C79.3665242,22.6668433 79.341552,22.9242938 79.2919567,23.1775393 Z",
    id: "Rectangle",
    fill: "#FFCC7B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-28",
    transform: "translate(0.000000, 97.467532)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,0 L39.6665005,0 L39.6665005,0 L52.3589412,12.995671 L52.3589412,55.7294372 C52.3589412,59.0431457 49.6726497,61.7294372 46.3589412,61.7294372 L6,61.7294372 C2.6862915,61.7294372 1.29399067e-15,59.0431457 0,55.7294372 L0,6 C-1.29399067e-15,2.6862915 2.6862915,6.08718376e-16 6,0 Z",
    id: "Rectangle",
    fill: "#B7B1FB"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(10.656168, 19.728729)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#000000",
    fillRule: "nonzero",
    xlinkHref: "#path-7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    mask: "url(#mask-8)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-Color"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uD83C\\uDFA8-Icon-Color",
    x: 0,
    y: 0,
    width: 25.5748031,
    height: 25.5700935
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M52.3589412,12.995671 L42.6665005,12.995671 C41.0096462,12.995671 39.6665005,11.6525252 39.6665005,9.995671 L39.6665005,0 L39.6665005,0 L52.3589412,12.995671 Z",
    id: "Path",
    fill: "#7367F0",
    fillRule: "nonzero",
    opacity: 0.339960007
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(22.907037, 257.747475)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,0 L68.1751666,0 C71.4888751,7.33259634e-15 74.1751666,2.6862915 74.1751666,6 L74.1751666,55.7294372 C74.1751666,59.0431457 71.4888751,61.7294372 68.1751666,61.7294372 L6,61.7294372 C2.6862915,61.7294372 4.82055882e-15,59.0431457 0,55.7294372 L0,6 C-4.05812251e-16,2.6862915 2.6862915,-2.79460044e-16 6,0 Z",
    id: "Rectangle",
    fill: "#6FD9E6"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.312336, 15.981308)",
    id: "Icon"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-10",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-9"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#000000",
    fillRule: "nonzero",
    xlinkHref: "#path-9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    mask: "url(#mask-10)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-Color"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uD83C\\uDFA8-Icon-Color",
    x: 0,
    y: 0,
    width: 29.8372703,
    height: 29.8317757
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group-34",
    transform: "translate(87.264902, 60.646465)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-12",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-11"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Rectangle",
    fill: "#BAF3C4",
    fillRule: "nonzero",
    xlinkHref: "#path-11"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFFFFF",
    mask: "url(#mask-12)",
    cx: 32.7243382,
    cy: 22.7424242,
    rx: 9.81730147,
    ry: 9.74675325
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#28C76F",
    mask: "url(#mask-12)",
    cx: 10.3627071,
    cy: 73.1006494,
    rx: 35.4513664,
    ry: 35.1966089
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#69E09E",
    mask: "url(#mask-12)",
    cx: 74.7205723,
    cy: 64.978355,
    rx: 41.996234,
    ry: 41.1529582
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-23",
    transform: "translate(185.437917, 35.738095)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-14)",
    xlinkHref: "#path-13"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-13"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M44.6997462,101.799423 L86.1976067,101.799423 C87.9919344,101.799423 89.4465245,103.254013 89.4465245,105.048341 C89.4465245,106.842668 87.9919344,108.297258 86.1976067,108.297258 L44.6997462,108.297258 C42.9054184,108.297258 41.4508284,106.842668 41.4508284,105.048341 C41.4508284,103.254013 42.9054184,101.799423 44.6997462,101.799423 Z",
    id: "Rectangle",
    fill: "#7367F0",
    fillRule: "nonzero",
    opacity: 0.339960007
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7916334,119.126984 L97.1057195,119.126984 C98.9000472,119.126984 100.354637,120.581574 100.354637,122.375902 C100.354637,124.17023 98.9000472,125.62482 97.1057195,125.62482 L33.7916334,125.62482 C31.9973057,125.62482 30.5427157,124.17023 30.5427157,122.375902 C30.5427157,120.581574 31.9973057,119.126984 33.7916334,119.126984 Z",
    id: "Rectangle",
    fill: "#7367F0",
    fillRule: "nonzero",
    opacity: 0.339960007
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon8",
    transform: "translate(40.360017, 27.074315)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-16)",
    xlinkHref: "#path-15"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-15"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-70",
    transform: "translate(15.271358, 11.912698)",
    fill: "#7367F0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.4202043,14.5949316 C18.362298,14.5949316 20.7473362,16.9799698 20.7473362,19.9220635 L20.7473362,23.9374646 C20.7473362,24.6619136 20.1600543,25.2491955 19.4356054,25.2491955 L1.31173083,25.2491955 C0.587281895,25.2491955 4.12501135e-12,24.6619136 4.12470058e-12,23.9374646 L4.12470058e-12,19.9220635 C4.12434028e-12,16.9799698 2.38503822,14.5949316 5.32713196,14.5949316 L15.4202043,14.5949316 Z M10.3736681,9.84101689e-13 C13.9297349,9.84101689e-13 16.8124966,2.86204586 16.8124966,6.39255835 C16.8124966,9.92307084 13.9297349,12.7851167 10.3736681,12.7851167 C6.81760134,12.7851167 3.93483963,9.92307084 3.93483963,6.39255835 C3.93483963,2.86204586 6.81760134,9.84101689e-13 10.3736681,9.84101689e-13 Z",
    id: "Combined-Shape"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Wom3.5",
    transform: "translate(250.886593, 75.808081)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "RArm",
    transform: "translate(108.670044, 62.119558)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.1800746,83.4999028 C16.1800746,83.4999028 4.59640049,96.0748486 5.40202065,97.2077558 C6.20843302,98.348118 12.2110368,95.3042259 12.2110368,95.3042259 C12.2110368,95.3042259 5.18022354,108.2565 6.80468089,109.143091 C8.42834333,110.029681 16.3893357,107.670968 18.7305059,104.956421 C21.072471,102.241873 24.2317332,88.9772411 24.2317332,88.9772411 L41.0359196,53.597517 L27.3664649,49.6532827 L16.1800746,83.4999028 Z",
    id: "Path",
    fill: "url(#linearGradient-17)",
    transform: "translate(23.198893, 79.493081) rotate(2.866471) translate(-23.198893, -79.493081) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.53178906,19.377995 C8.6543155,27.280336 25.8980902,49.8011527 25.8980902,49.8011527 C25.8980902,49.8011527 25.4792619,51.2988403 24.6416051,54.2942154 L40.4884268,65.0799328 C43.4896706,56.8484686 45.1205056,52.1537029 45.3809319,50.9956355 C46.6692588,45.2656107 20.6349407,8.69859298 14.8057262,3.41487339 C5.62711821,-4.9051227 -4.29692937,7.3016493 3.53178906,19.377995 Z",
    id: "Path",
    fill: "#FD8715"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0196737,55.7795696 C30.2167067,55.3979686 28.8513959,53.3782106 25.9237413,49.7202957 L25.1796782,52.3886114 C28.2093089,55.0308513 29.8226408,56.1611707 30.0196737,55.7795696 Z",
    id: "Path",
    fillOpacity: 0.159855769,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-70",
    fill: "#FFEDC2",
    points: "24.5432537 52.7866689 41.3789984 65.5508182 37.6274586 73.8058508 22.9070368 57.5502591"
  })), /*#__PURE__*/React.createElement("g", {
    id: "RLeg",
    transform: "translate(80.353000, 132.676491)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "url(#linearGradient-18)",
    points: "42.2329316 214.539555 41.2978592 230.35785 53.2850655 230.667766 51.0319867 214.539555"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5261034,220.771259 C42.5261034,220.771259 42.8625132,230.297168 40.8755931,233.623019 C38.8760577,236.948871 38.2701024,239.52728 38.1817948,241.516218 C38.0871796,243.648283 38.2900767,245.57997 38.2900767,245.57997 L58.1306979,245.57997 C58.1306979,245.57997 58.62732,235.557887 57.3132195,233.667548 C55.999119,231.778269 55.137069,231.745403 55.137069,230.075586 C55.1265562,228.405769 54.8427105,220.833811 54.8427105,220.833811 L42.5261034,220.771259 Z",
    id: "Path",
    fill: "#391B0B",
    transform: "translate(48.189688, 233.175614) scale(-1, 1) translate(-48.189688, -233.175614) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,3.35605166 L31.0964302,-1.23119728e-13 L31.5536398,0.421520837 C33.7699405,2.51807878 43.401517,12.2547835 46.1690133,25.5632082 C51.3938288,50.6884683 44.401132,97.0931666 44.5558057,107.268752 C44.7034487,117.444337 49.5467086,123.583964 51.559368,137.971405 C53.5720273,152.358846 53.7620824,216.658374 53.7620824,216.658374 C48.4258421,219.798021 43.7304535,220.022781 37.3677429,216.469911 L0,3.35605166 Z",
    id: "Path",
    fill: "#4E3319"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7772192,161.771085 L8.33198129e-14,3.35605166 L17.2896937,1.48992364 C18.060045,56.5229442 28.812274,130.912593 27.7772192,161.771085 Z",
    id: "Path",
    fillOpacity: 0.192498907,
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LLeg",
    transform: "translate(53.824274, 137.035582)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.8984667,208.517106 L22.6759459,208.681837 C23.1240689,215.704761 22.0379549,220.405728 19.417604,222.784736 L19.2028199,222.971491 C14.4571517,226.920131 32.7648849,225.494796 32.7648849,225.494796 L32.8984667,208.517106 Z",
    id: "Path",
    fill: "url(#linearGradient-19)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.716289393,216.728735 L1.01046288,241.212168 L8.28942356,241.217498 L8.35246074,235.184524 C8.35246074,235.184524 10.6483108,240.809196 14.1573802,241.134291 C17.6769559,241.459385 33.3590402,241.260065 33.3590402,241.260065 C33.3590402,241.260065 34.6618085,235.611943 26.8557049,233.047426 C20.3628758,230.915657 13.1835026,216.728735 13.1835026,216.728735 L0.716289393,216.728735 Z",
    id: "Path",
    fill: "#391B0B",
    transform: "translate(17.078459, 229.024636) scale(-1, 1) translate(-17.078459, -229.024636) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1035461,1.17475028 L46.0220768,0 L46.2829851,0.479578386 C47.9773367,3.67010932 57.2613967,22.3507767 54.3946345,43.584011 C50.3707246,73.3878873 40.14164,108.327433 39.6408309,113.664932 C38.7479422,123.181117 40.5337195,130.071628 41.2659692,139.90064 C41.9982189,149.729653 38.473748,211.547188 38.473748,211.547188 C33.2921814,214.641464 27.1263281,215.248733 19.2871873,211.640721 C14.569383,155.662775 12.1930526,123.244341 12.1581963,114.38542 C12.1059118,101.097037 11.1035461,1.17475028 11.1035461,1.17475028 Z",
    id: "Path",
    fill: "#604021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2887052,33.4112408 L18.057017,35.6194657 C15.7299121,58.9046521 15.747538,108.353859 16.6486707,115.980096 L16.772331,116.96301 C17.7718083,125.568633 17.8042169,147.416338 16.8695568,182.506124 L15.652943,167.364353 C13.3474537,138.228072 12.1825242,120.568476 12.1581963,114.38542 L12.115961,107.986444 C11.9154624,82.1118028 11.1035461,1.17475028 11.1035461,1.17475028 L18.4677533,0.927266517 C19.2548707,13.703649 19.195188,24.5316404 18.2887052,33.4112408 Z",
    id: "Path",
    fillOpacity: 0.192498907,
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Head",
    transform: "translate(75.122745, 3.647605)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.12008554,24.1972659 C-1.17647519,24.6639446 -0.871868273,32.1632738 4.35839282,32.5548255 C5.42740279,39.7842068 9.23979884,43.2285884 13.8877798,43.6271435 L13.6299861,54.5619409 L34.1893499,54.5498442 C34.1893499,54.5498442 28.3998946,46.825134 28.6884696,36.2500548 C28.9770446,25.6743389 28.4948037,15.7397492 28.4948037,15.7397492 L1.86574632,16.2140679 L3.12008554,24.1972659 Z",
    id: "Path",
    fill: "url(#linearGradient-20)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6529251,24.7591317 C29.6487318,22.7943966 25.9521033,31.2535094 22.1231644,37.1328396 C18.2942255,43.0121697 8.37407063,42.0132242 7.00683743,37.1328396 C1.83059816,26.4436587 -2.63015622,11.9113045 3.41030392,10.7185525 C4.26055654,-4.73024433 44.9886164,-1.08297258 34.6529251,24.7591317 Z",
    id: "Path",
    fill: "#8B5030",
    transform: "translate(18.419009, 21.358475) scale(-1, 1) translate(-18.419009, -21.358475) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.436082,4.87110373 C32.1802338,6.34261802 33.29437,8.29575177 33.4277133,10.7185525 C39.4681734,11.9113045 35.007419,26.4436587 29.8311798,37.1328396 C28.5597933,41.6710962 19.892618,42.8530373 15.604868,38.2689348 C11.6943611,26.6386578 13.3646567,13.6346942 21.2708198,4.87337662 L21.2708198,4.87337662 Z",
    id: "Combined-Shape",
    fillOpacity: 0.199355332,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FB9934",
    cx: 24.6864866,
    cy: 4.87337662,
    rx: 4.90865073,
    ry: 4.87337662
  })), /*#__PURE__*/React.createElement("g", {
    id: "Body",
    transform: "translate(60.157027, 54.738549)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.2563712,5.58883306 C57.8431259,12.2784694 65.4875521,34.9828511 65.9211182,40.0906083 C66.4096074,45.9824229 60.0476166,55.3679639 59.9429404,63.8972108 C59.8498948,72.4276195 64.6882644,98.111795 63.2344274,100.511045 C61.7922211,102.910295 20.4383798,113.5327 17.7400583,113.475768 C15.0533675,113.417675 -1.9091019,98.959956 0.219315501,93.9639389 C2.3593636,88.9679218 12.2919781,76.5522383 11.2801076,69.7448745 C10.2798677,62.9386726 4.47120197,37.813354 1.58678932,29.2620316 C-1.28599264,20.7107093 -0.328067355,11.7327529 5.03368358,8.05312822 C7.68670553,6.23243099 14.7661203,1.05981695 27.3732956,1.08297258 C39.9804709,1.10724295 52.9006727,5.07005803 53.2563712,5.58883306 Z",
    id: "Path",
    fill: "#FD8715",
    transform: "translate(32.973935, 57.280041) scale(-1, 1) translate(-32.973935, -57.280041) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9264911,0.59427726 C26.5727774,2.51209074 27.1701335,3.47099748 28.7185595,3.47099748 C31.0411984,3.47099748 46.6203061,3.9803773 48.7300712,3.07076598 C50.1365813,2.46435843 50.6288197,1.63886219 50.2067864,0.59427726 L26.9264911,0.59427726 Z",
    id: "Path-68",
    fill: "#FFF6E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.03431574,20.0572003 L6.17549872,19.9865519 C14.670143,15.7765583 19.7726218,15.5906007 21.4829351,19.4286788 C23.693832,24.3901061 17.9604287,36.3115934 4.28272508,55.1931408 C2.40404229,49.4667406 -0.297945396,44.006874 0.0267514553,40.0906083 C0.277664491,37.1346512 2.94360927,28.2853045 6.03431574,20.0572003 Z",
    id: "Path",
    fillOpacity: 0.159855769,
    fill: "#000000"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LArm",
    transform: "translate(0.000000, 28.555975)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.52631989,32.2942424 C9.52631989,32.2942424 7.99602807,28.9962101 5.5905072,28.103881 C3.18566991,27.2115518 -0.493107746,21.3012078 0.0756314886,19.584878 C0.644370723,17.8685481 5.62015544,13.1085573 5.62015544,13.1085573 C5.62015544,13.1085573 1.22131293,1.38853436 3.16951824,0.0659388409 C4.89077472,-1.10308677 11.4046163,13.6592441 11.4046163,13.6592441 C11.4046163,13.6592441 15.234036,14.2322561 16.1179059,15.741571 C18.3450122,19.5463164 16.6615364,28.103881 16.6615364,28.103881 L39.2692059,60.9025612 L28.8956529,74.1079483 L9.52631989,32.2942424 Z",
    id: "Path",
    fill: "url(#linearGradient-21)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.2376489,34.8374889 C59.5916946,41.5810915 40.8901124,59.4721391 40.8901124,59.4721391 C40.8901124,59.4721391 39.9638936,58.0631272 38.111456,55.2451035 L24.1255107,69.4640633 C31.1590514,79.8215961 35.8210332,85.0365446 38.111456,85.1089091 C47.0630518,85.3915903 63.1020488,68.6121675 78.1810532,55.5101474 C91.7011114,43.7623231 81.4900462,22.2670877 67.2376489,34.8374889 Z",
    id: "Path",
    fill: "#FD8715"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.9459036,59.4931492 C37.4483932,63.509174 35.5553414,65.2982151 35.2667481,64.8602725 C34.9781547,64.4223298 36.297263,61.762325 39.2240729,56.8802578 L40.9459036,59.4931492 Z",
    id: "Path",
    fillOpacity: 0.159855769,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-69",
    fill: "#FFEDC2",
    points: "39.7858401 56.2028326 23.5649159 74.1079483 18.567233 63.8899546 36.6998371 52.5928893"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M114.094106,4.64227968 C114.094106,4.64227968 109.500942,-1.2978111 104.196944,0.26060551 C98.8929461,1.81902212 94.0951866,11.3718834 96.3732594,20.3513868 C98.6398269,29.3320533 96.7706504,34.4542419 94.0208555,40.5064808 C86.6343769,56.7872824 112.20829,67.12462 112.20829,67.12462 C110.878013,59.0820037 111.506619,52.6324772 114.094106,47.7760405 C118.091315,40.2737053 120.361426,30.6529316 120.361426,24.7655709 C120.361426,14.5276202 114.094106,4.64227968 114.094106,4.64227968 Z",
    id: "Path",
    fill: "#8B5030",
    transform: "translate(106.521468, 33.562310) scale(-1, 1) translate(-106.521468, -33.562310) "
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-39",
    transform: "translate(292.337421, 7.580808)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,7.69613675 C18.479812,-2.875938 37.2122537,-2.25004902 56.1549644,7.69613675 L54.9548985,20.9648737 C53.328432,38.948182 43.3838469,55.1355008 28.0774822,64.7146432 L28.0774822,64.7146432 L28.0774822,64.7146432 C12.1078722,55.2017329 1.87480546,38.4081297 0.742197589,19.854394 L0,7.69613675 L0,7.69613675 Z",
    id: "Rectangle",
    fill: "#28C76F"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#1CA258",
    cx: 28.0774822,
    cy: 29.1427922,
    rx: 15.3149903,
    ry: 15.2049351
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-40",
    transform: "translate(16.591239, 17.739091)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.2677319,0.601862013 C16.1385794,0.601862013 20.3548504,3.86164103 21.5782793,8.45789189 C21.672825,8.81308691 21.4594429,9.17712304 21.1016769,9.27098935 C20.7439109,9.36485566 20.3772399,9.15300688 20.2826941,8.79781187 C19.2139095,4.78253791 15.5273402,1.93229383 11.2677319,1.93229383 C6.11916511,1.93229383 1.94628002,6.06077247 1.94628002,11.1521339 C1.94628002,14.0260372 2.89532809,16.6095976 4.80550115,18.9268403 C5.03986794,19.2111521 4.99771126,19.6302589 4.71134159,19.8629415 C4.42497192,20.0956241 4.00283161,20.0537704 3.76846483,19.7694586 C1.66432616,17.216915 0.606218366,14.3364651 0.606218366,11.1521339 C0.606218366,5.32495486 5.3801134,0.601862013 11.2677319,0.601862013 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8442325,3.46016329 C15.8515366,3.46905023 19.1118473,6.57567827 19.2397072,10.5003805 L19.2435831,10.7233919 C19.2484677,12.9173361 19.8676595,14.1226801 21.0557367,14.5151765 C21.4071058,14.6312557 21.5985733,15.0081678 21.4833914,15.3570333 C21.3682094,15.7058988 20.9899951,15.8946093 20.638626,15.7785301 C18.867855,15.1935335 17.9713615,13.5437847 17.9081161,10.9880402 L17.9045441,10.7204275 C17.8972235,7.43233043 15.1964281,4.79904232 11.8471968,4.79162782 C8.83223121,4.78495333 6.26740115,7.54781764 5.9120832,10.6399155 C5.84290167,11.2419567 5.82607432,11.7979282 5.86025874,12.3510425 L5.89740551,12.8315672 C6.04415714,14.3585513 6.48561255,15.617762 8.56622472,21.047984 C8.69806244,21.3920693 8.52488347,21.7760378 8.17941866,21.9056017 C7.83395386,22.0351656 7.44702371,21.8612617 7.31518599,21.5171764 L6.20333114,18.592748 C4.8782327,15.0568129 4.63488171,14.094829 4.53078745,12.5365545 L4.52373914,12.4268303 C4.48464405,11.7942599 4.50382341,11.1605788 4.58168832,10.4829718 C5.00856047,6.76818487 8.08717914,3.45186158 11.8442325,3.46016329 Z",
    id: "Path",
    transform: "translate(13.010484, 12.704325) rotate(-19.000000) translate(-13.010484, -12.704325) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5576461,7.10607183 C14.6334458,7.11067802 16.3461366,8.8093325 16.2852706,10.8624468 C16.1975808,13.8203749 17.1586796,16.0074381 19.1748625,17.4988912 C19.472164,17.7188172 19.5349409,18.1359573 19.3150788,18.4305995 C19.0952166,18.7252418 18.6759727,18.7858113 18.3786712,18.5658852 C15.9927859,16.8009482 14.8467328,14.1930057 14.9468076,10.8173124 C14.9850852,9.52614192 13.890448,8.44047572 12.5606104,8.43753174 C11.1446659,8.43439714 10.0998538,9.43169095 9.87347291,11.2113637 C9.75841299,12.1158969 10.0570836,13.5046747 10.7238722,15.4100567 L10.8384043,15.7324092 C10.9336325,15.996591 11.0347926,16.2688196 11.1457087,16.5600434 L12.3584382,19.6523084 C12.4892076,19.9967926 12.3148331,20.3802218 11.9689618,20.5087214 C11.6230906,20.637221 11.2366971,20.4621309 11.1059277,20.1176467 L10.1338575,17.6485656 L9.89306724,17.025044 C9.77970701,16.7273787 9.6760278,16.4483541 9.57810879,16.1767075 L9.34660472,15.5157956 C8.69247482,13.587717 8.40413464,12.1459265 8.5450008,11.0385198 C8.85287872,8.61816523 10.4419149,7.10139887 12.5576461,7.10607183 Z",
    id: "Path",
    transform: "translate(13.978186, 13.828478) rotate(-19.000000) translate(-13.978186, -13.828478) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6387038,11.5582086 C11.9925256,11.4506104 12.3672116,11.6481528 12.4755886,11.9994319 C13.1978427,14.3404528 14.6122229,16.0009847 17.2723103,17.9840234 C17.5682242,18.204621 17.6279858,18.6216125 17.4057915,18.9154 C17.1835972,19.2091875 16.7635875,19.2685196 16.4676736,19.047922 C13.6017464,16.9114341 12.014664,15.0481438 11.1942868,12.3890794 C11.0859098,12.0378003 11.2848821,11.6658067 11.6387038,11.5582086 Z",
    id: "Path"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForgotPassword);
export default __webpack_public_path__ + "static/media/forgot-password.92f01a1f615791b3231616e1f993bf3e.svg";
export { ForwardRef as ReactComponent };